/**
 *  Games launcher
 */

define(function(require, exports, module) {
    'use strict';
    const _ = require('underscore');
    const Launcher = require('modules/launcher/launcher');

    _.extend(Launcher, {
        /**
         * Game that launched right now
         * @type {Object}
         */
        _handleSuccessLogin: function(gameCode, mode, queryString, options) {
            this.launchGame(gameCode, mode, queryString, options);
        }
    });

    module.exports = Launcher;
});
